import { HStack } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import InteractiveTooltip from "../shared/InteractiveTooltip"
import ShareDropdown from "../shared/ShareDropdown"
import { useSelectPeopleContext } from "./SelectPeopleContext"
import SelectRoleDescriptorsDrawerOption from "./SelectRoleDescriptorsDrawerOption"
import { getRoleLabel } from "./utils"
import { isInviteRoleGated, isInviteRoleVisible } from "../shared/rolesConfig"

const SelectItemRole = ({ item }) => {
  const {
    rolePermissions,
    permissions,
    peopleSelection: { queued },
    roleSelection: { selected, pending },
    addToPeopleSelection,
    updateRoleSelection
  } = useSelectPeopleContext()
  const { t, tc, tca } = useTranslate()

  const roleOptions = Object.keys(rolePermissions).reduce((acc, key) => {
    const invite = rolePermissions[key]
    if (!isInviteRoleVisible(invite)) return acc

    acc.push({
      value: key,
      label: getRoleLabel("verb", key, tca),
      disabled: isInviteRoleGated(invite)
    })

    return acc
  }, [])

  const role = queued.length ? pending[item.meta.key] : selected[item.meta.key]

  return (
    <SelectRoleDescriptorsDrawerOption>
      {({ option: drawerOption, onOpen }) => {
        const handleChange = (value) => {
          switch (value) {
            case drawerOption.value:
              onOpen()
              break
            default:
              // Automatically add this item to the people selection as a convenience.
              addToPeopleSelection(item)
              updateRoleSelection(item, value)
          }
        }

        return (
          <ShareDropdown
            name="role"
            value={role ? [role] : []}
            options={[...roleOptions, drawerOption]}
            onChange={handleChange}
          />
        )
      }}
    </SelectRoleDescriptorsDrawerOption>
  )
}

export default SelectItemRole
